import React, { useContext } from 'react'
import { ComponentConfig, renderContext } from '@puckeditor/core'
import { DropdownButton } from 'steps/listicle/components/DropdownButton'
import analytics from 'global/AnalyticsData'

export type ListicleMenuProps = {
  text?: string
  items?: { label: string; link: string }[]
}

function ListicleMenuRender({ text, items }: ListicleMenuProps) {
  const puckCtx = useContext(renderContext)
  const step = (puckCtx.metadata ?? {}).step

  // DropdownButton requires each item to carry id/label/link.
  const mappedItems = (items ?? []).map((it, i) => ({
    id: `${i}`,
    label: it.label,
    link: it.link,
  }))

  return (
    <DropdownButton
      text={text}
      items={mappedItems}
      onClick={(_id: string, buttonText: string, url: string) => {
        if (step) {
          analytics.stepEvent('step_interaction_listicle_button_click', step, {
            result: `${buttonText} | ${url}`,
          })
        }
      }}
    />
  )
}

export const PuckListicleMenu: ComponentConfig<ListicleMenuProps> = {
  label: 'Listicle Menu',
  defaultProps: {
    text: 'Menu',
    items: [],
  },
  fields: {
    text: { type: 'text', label: 'Button Label' },
    items: {
      type: 'array',
      label: 'Links',
      arrayFields: {
        label: { type: 'text', label: 'Link Label' },
        link: { type: 'text', label: 'Link URL' },
      },
    },
  },
  render: ListicleMenuRender,
}
